import React, { useEffect, useState } from 'react'

import { BellOutlined, ClockCircleOutlined, CommentOutlined, FlagOutlined, GiftOutlined, MailOutlined, NotificationOutlined, OrderedListOutlined, SaveOutlined, UsergroupAddOutlined, UserOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { orange, purple, yellow,cyan,  } from "@ant-design/colors";
import {Button, Col, ConfigProvider, Form, Input, Modal, Row, Steps, Typography } from 'antd';


import ChannelPushNotificationContent from './channels/channel_push_notification/ChannelPushNotificationContent';
import MarketingOperationCreateSelectAudience from './MarketingOperationCreateSelectAudience';
import MarketingOperationCreateSelectPriority from './MarketingOperationCreateSelectPriority';
import MarketingOperationCreateSelectChannel from './MarketingOperationCreateSelectChannel';
import ChannelWhatsAppContent from './channels/channel_whatsapp/ChannelWhatsAppContent';
import { convertFullDateToDayjs, nowDateTimeIta } from '../../../helpers/DateUtils';
import MarketingOperationCreateSchedule from './MarketingOperationCreateSchedule';
import ChannelCouponContent from './channels/channel_coupon/ChannelCouponContent';
import ChannelEmailContent from './channels/channel_email/ChannelEmailContent';
import ChannelSmsContent from './channels/channel_sms/ChannelSmsContent';
import { CreateOperationDataContext } from '../../../helpers/Context';
import { DEBUG_MODE, PRIMARY_COLOR } from '../../../helpers/Globals';
import { ifViewportGreaterThan } from '../../../helpers/Viewport';
import { apiSetOperation, apiUpdateOperation } from '../../../helpers/Api';

import dayjs from 'dayjs';
import { toHaveFormValues } from '@testing-library/jest-dom/dist/matchers';

export default function MarketingOperationCreateContent({contextValue, userId, preSelectedAudience, operationData, onSave, closeModal}) {
   
   const { publicCode, successNotification, errorNotification } = contextValue;
   const globalContext = contextValue;
   
   const channelsGroupObjLabel = "operation_channels";

   // -------- variabili della modal di salvataggio --------
   
   const [savingOperation, setSavingOperation] = useState(false);
   const [openSaveModal, setOpenSaveModal] = useState(false);
   const [operationGeneralInfoForm] = Form.useForm();

   // -------- variabili della modal di salvataggio --------

   // -------- colori preset delle aree --------

   const colorWhatsApp           = PRIMARY_COLOR;
   const colorPushNotification   = yellow[6];
   const colorCoupons            = orange[6];
   const colorSms                = purple[5];
   const colorEmail              = cyan[7];
   
   // -------- colori preset delle aree --------  
   
   // --------- variabili per l'audience ---------
   const [selectedAudience, setSelectedAudience] = useState((preSelectedAudience !== "" && preSelectedAudience) ? [preSelectedAudience] : []);
   const [selectedAudienceTitles, setSelectedAudienceTitles] = useState([]);
   const [totalUsers, setTotalUsers] = useState(0);
   // --------- variabili per l'audience ---------

   // --------- variabili per lo scheduling ---------
   const [monthlyOption, setMonthlyOption] = useState('specificDay');
   const [repeatFrequency, setRepeatFrequency] = useState('immediate');
   const [selectedDays, setSelectedDays] = useState([]);
   // --------- variabili per lo scheduling ---------

   // --------- variabili per i dati coupon nei componenti ---------
   const [selectedCoupon, setSelectedCoupon] = useState('');
   // --------- variabili per i dati coupon nei componenti ---------

   // --------- variabili del form --------------
   const [focusedInputName, setFocusedInputName] = useState(null);
   const [focusedInputRef, setFocusedInputRef] = useState(null);
   const [formIsValid, setFormIsValid] = useState(true);
   const [formChanged, setFormChanged] = useState(0);
   const [formValues, setFormValues] = useState([])
   const [form] = Form.useForm();
   
   const [schedulingData, setschedulingData] = useState(null);
   
   const [selectedValues, setSelectedValues] = useState([]);

   const [pushNotificationData, setpushNotificationData] = useState(null)
   const [whatsAppData, setwhatsAppData] = useState(null)
   const [couponData, setcouponData] = useState(null)
   const [emailData, setemailData] = useState(null)
   const [smsData, setsmsData] = useState(null)

      // Definisci un oggetto con i nomi delle variabili da settare
         const formFields = {
            schedulingData: {
               path: 'schedulingData',
               setter: setschedulingData
            },
            PUSH: {
               path: `${channelsGroupObjLabel}.PUSH`,
               setter: setpushNotificationData
            },
            WHATSAPP: {
               path: `${channelsGroupObjLabel}.WHATSAPP`,
               setter: setwhatsAppData
            },
            COUPON: {
               path: `${channelsGroupObjLabel}.COUPON`,
               setter: setcouponData
            },
            EMAIL: {
               path: `${channelsGroupObjLabel}.EMAIL`,
               setter: setemailData
            },
            SMS: {
               path: `${channelsGroupObjLabel}.SMS`,
               setter: setsmsData
            }
         };
      
   // --------- variabili del form --------------


      const disabledClass = "opacity-03 pointer-no-event coming-soon-badge";

      //definisco i canali che possono essere selezionati per le operazioni, verranno poi renderizzate nelle singole tab dei dati dei canali
      
      const channelsOptions = [
          {
            label: 'Notifica Push',
            value: 'PUSH',
            key: 'PUSH',
            className: "operation-push-notification",
            color:colorPushNotification,
            icon:<BellOutlined/>,
            children: (
                <ConfigProvider
                  theme={{
                      token: {
                        colorPrimary: colorPushNotification,
                      }
                  }}
                >
                  <div className='di-tab-channel-content'>
                      <ChannelPushNotificationContent/>
                  </div>
                </ConfigProvider>
            ),
          },
          {
            label: 'Coupon',
            value: 'COUPON',
            key: 'COUPON',
            className: "operation-coupons ",
            color:colorCoupons,
            icon:<GiftOutlined/>,
            children: (
                <ConfigProvider
                  theme={{
                      token: {
                        colorPrimary: colorCoupons,
                      }
                  }}
                >
                  <div className='di-tab-channel-content'>
                      <ChannelCouponContent/>
                  </div>
                </ConfigProvider>
            ),
          },
          {
            label: 'E-mail',
            value: 'EMAIL',
            key: 'EMAIL',
            icon: <MailOutlined />,
            color:colorEmail,
            className:"operation-email " + disabledClass,
            children: (
                <ConfigProvider
                  theme={{
                      token: {
                        colorPrimary: colorEmail,
                      }
                  }}
                >
                  <div className='di-tab-channel-content'>
                      <ChannelEmailContent/>
                  </div>
                </ConfigProvider>
            ),
          },
          {
            label: 'SMS',
            value: 'SMS',
            key: 'SMS',
            icon: <CommentOutlined />,
            color:colorSms,
            className:"operation-sms ",
            children: (
              <ConfigProvider
                  theme={{
                      token: {
                        colorPrimary: colorSms,
                      }
                  }}
                >
                  <div className='di-tab-channel-content'>
                      <ChannelSmsContent/>
                  </div>
                </ConfigProvider>
            ),
          },
          {
            label: 'WhatsApp',
            value: 'WHATSAPP',
            key: 'WHATSAPP',
            className: "operation-whatsapp " + disabledClass,
            color:colorWhatsApp,
            icon:<WhatsAppOutlined/>,
            children: (
                <ConfigProvider
                  theme={{
                      token: {
                        colorPrimary: colorWhatsApp,
                      }
                  }}
                >
                  <div className='di-tab-channel-content'>
                      <ChannelWhatsAppContent/>
                  </div>
              </ConfigProvider>
            ),
          },
      ];
  
    //definisco i canali che possono essere selezionati per le operazioni

   
      ///////////////////////////////////////////////////////////////////////////////////////////
         ////////// inizializzo dei valori del form se trattasi di modifica audience //////
   ///////////////////////////////////////////////////////////////////////////////////////////
   
         useEffect(() => {
            if (!operationData) return;
            
               // 🔹 1. Split dei dati generali
               const { title, description, schedule, operation_channels: rawChannels, priority, audienceCampaignIds } = operationData;

               // 🔹 2. Trasforma operation_channels in oggetto (da array di oggetti singola chiave)
               const operation_channels = {};
               (rawChannels || []).forEach(channelObj => {
                  const key = Object.keys(channelObj)[0]; // es. "PUSH"
                  const data = channelObj[key];
                  operation_channels[key] = data;
               });

               // 🔹 3. Trasforma schedule se presente (prendi il primo elemento)
               const scheduleRaw = operationData.schedule?.[0] || {};

               const transformedSchedule = {
               ...scheduleRaw, // <-- include tutto così com'è
               full_date: scheduleRaw.full_date?.map(d => dayjs(d)),
               execution_times: scheduleRaw.execution_times?.[0]
                  ? dayjs(scheduleRaw.execution_times[0])
                  : undefined,
               };
            
               // 🔹 4. Imposta i valori nel form
               form.setFieldsValue({
                  title,
                  description,
                  schedule: transformedSchedule,
                  operation_channels,
                  priority,
                  audienceCampaignIds
               });

               operationGeneralInfoForm.setFieldsValue({ title, description });

               // 🔹 5. Setta le audience
               setSelectedAudience(audienceCampaignIds);

               // 🔹 6. Calcola i canali attivi partendo da `operation_channels`
               const activeChannelValues = Object.keys(operation_channels);
               const matchingChannels = channelsOptions.filter(option =>
                  activeChannelValues.includes(option.value)
               );
               setSelectedValues(matchingChannels);

               // 🔹 7. Gestisco gli stati dello schedule
               setRepeatFrequency(scheduleRaw?.schedule_type);
               setSelectedDays(scheduleRaw?.days_of_week)
         }, []);

      /////////////////////////////////////////////////////////////////////////////////////////// 
         ////////// inizializzo dei valori del form se trattasi di modifica audience //////
      ///////////////////////////////////////////////////////////////////////////////////////////

   // ------------ funzioni tecniche degli input -----------——
   
   const insertShortcode = (shortcode) => {
   const input = focusedInputRef; 

   if (!input || typeof input.selectionStart !== 'number') {
      console.error("Input non valido o non è un campo testuale:", input);
      return;
   }

   const { selectionStart, selectionEnd } = input;

   const value = form.getFieldValue(focusedInputName) || "";
   const textBeforeCursor = value.substring(0, selectionStart);
   const textAfterCursor = value.substring(selectionEnd);

   const newValue = `${textBeforeCursor}${shortcode}${textAfterCursor}`;
   form.setFieldValue(focusedInputName, newValue);
   handleFormChange();

   setTimeout(() => {
      const cursorPos = selectionStart + shortcode.length;
      input.setSelectionRange(cursorPos, cursorPos);
      input.focus();
   }, 0);
   };


   
   const onInputFocus = (inputRef, inputName) => {
      setFocusedInputName(inputName);
      setFocusedInputRef(inputRef.current); 
   };
      
   // ------------ funzioni tecniche degli input -----------——

   
   // --------- funzioni del form --------------

   
   const handleFormChange = () => {
      setFormChanged(formChanged + 1);
   }

   //---------- gestione del click sul submit e invio form finito ------------
   const handleFinish = () => {
      
      if (!formIsValid) {
         form.validateFields()
         return;
      };

      const values = form.getFieldsValue();
      setFormValues(values);
      setOpenSaveModal(true);
   }
   
   useEffect(() => {
      const formValues = form.getFieldsValue();

      Object.entries(formFields).forEach(([key, { path, setter }]) => {
         // Split the path in caso di valori annidati (es. "operation_channels.PUSH")
         const value = path.split('.').reduce((obj, p) => obj?.[p], formValues);

         if (value !== undefined) {
            setter(value);
         }
      });

      if (DEBUG_MODE) {
         console.log("---- Valori del Form delle Operazioni ----");
         console.log(formValues);
         console.log("---- Valori del Form delle Operazioni ----");
         console.log("---- Operazioni selezionate ----");
         console.log(selectedValues);
         console.log("---- Operazioni selezionate ----");
      }

      setFormValues(formValues);
   }, [formChanged]);
   
   // --------- funzioni del form --------------

   // --------- steps del wizard --------------
   const [current, setCurrent] = useState(0);

   const steps = [
      {
         title: <span className='flex gap-5'><UsergroupAddOutlined/>Seleziona il Pubblico</span>,
      },
      {
         title: <span className='flex gap-5'><NotificationOutlined/>Seleziona il Canale</span>,
      },
      {
         title: <span className='flex gap-5'><OrderedListOutlined/>Seleziona le Priorità</span>,
      },
      {
         title: <span className='flex gap-5'><ClockCircleOutlined/>Seleziona la Ricorrenza</span>,
      },
   ]
   const filteredSteps = userId ? steps.slice(1) : steps;
   const totalSteps = filteredSteps.length; // Calcola il numero totale di steps visibili
   // --------- steps del wizard --------------

   
  ///////////////////////////////////////////////////////////////////////////////////////////
  //////////////////// funzione per creare l'array di pubblici selezionati ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  
   const onClickAudience = ({ audienceId, audienceTitle, audienceUsers }) => {
      // Calcola se è già selezionato
      const isAlreadySelected = selectedAudience.includes(audienceId);

      // Aggiorna gli ID selezionati
      const newSelectedIds = isAlreadySelected
         ? selectedAudience.filter((id) => id !== audienceId)
         : [...selectedAudience, audienceId];
      setSelectedAudience(newSelectedIds);

      // Aggiorna i titoli selezionati
      const newTitles = isAlreadySelected
         ? selectedAudienceTitles.filter((t) => t !== audienceTitle)
         : [...selectedAudienceTitles, audienceTitle];
      setSelectedAudienceTitles(newTitles);

      // Aggiorna il totale utenti
      const newTotal = isAlreadySelected
         ? totalUsers - audienceUsers
         : totalUsers + audienceUsers;
      setTotalUsers(newTotal);

      // Callback finale
      handleFormChange();
   };


  /////////////////////////////////////////////////////////////////////////////////////////// 
  //////////////////// funzione per creare l'array di pubblici selezionati ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////

   // ------------ navigatore -----------——
   const next = () => {
      setCurrent(current + 1);
      handleFormChange();
   };
   const prev = () => {
      setCurrent(current - 1);
      handleFormChange();
   };
   const onChange = (value) => {
      handleFormChange();
      setCurrent(value);
   };
   // ------------ navigatore -----------——  
   
   // ------------ operazioni ogni volta che cambia l'audience selezionata -----------——  
   useEffect(() => {
      form.setFieldValue("audienceCampaignIds", selectedAudience);
      handleFormChange();
   },[selectedAudience])
   // ------------ operazioni ogni volta che cambia l'audience selezionata -----------——  

   
    ///////////////////////////////////////////////////////////////////////////////////////////
            //////////////////// funzioni della modal di salvataggio ///////////////
   ///////////////////////////////////////////////////////////////////////////////////////////
   
   const handleCancel = () => {
      setOpenSaveModal(false);
   };

  const saveOperation = async () => {
     setSavingOperation(true);
     
      // Recupera i dati dal form
      const generalOperationData = operationGeneralInfoForm.getFieldsValue();
      
     const generalData = {
         id: operationData?.id, //se ho l'id dell'operazione ricevuto dalla getOperation singola, mando in update
         title: generalOperationData.operationName, // Usa i valori aggiornati del form
         description: generalOperationData.operationDescription,
         public_code: publicCode,
      };

      // trasformo l'oggetto operation_channels in array di oggetti
     function manipulateBody(payload) {
         
        
         if (!payload.operation_channels || typeof payload.operation_channels !== 'object') {
            return payload; // ritorna il payload com'è se non c'è operation_channels valido
         }

         const transformedChannels = Object.entries(payload.operation_channels).map(
            ([channel, data]) => ({ [channel]: data })
         );

         return {
            ...payload,
            operation_channels: transformedChannels
         };
      }

      
      //in questa funzione rende lo schedule un array di un solo oggetto
      function transformSchedule(obj) {
          if (obj && obj.schedule.execution_times && !Array.isArray(obj.schedule.execution_times)) {
            obj.schedule.execution_times = [obj.schedule.execution_times];
         }
         if (obj && obj.schedule && !Array.isArray(obj.schedule)) {
            obj.schedule = [obj.schedule];
         }
        
         return obj;
      }
     
     const manipulatedValues = transformSchedule(formValues);
     
      // Costruzione finale del body
      const body = {
         ...generalData,
         ...manipulateBody(manipulatedValues)
      }; //concateno le varie funzioni di pulizia json per avere il body
   
      try {
         // Esegui chiamata API
         const res = operationData
            ? await apiUpdateOperation(body)
            : await apiSetOperation(body);
         if (res && !res.error) {
            successNotification("Operazione salvata con successo");
            setSavingOperation(false);
            setOpenSaveModal(false); // Chiudi il modal di titolo e descrizione
            setTimeout(() => {
               closeModal(false); // Chiudi la pagina dell'operazione solo dopo il successo
               if(onSave) onSave();
            }, 200);
         } else {
            setSavingOperation(false);
            errorNotification(res.error.message);
            console.error("Errore nella risposta API:", res);
         }
      } catch (error) {
         setSavingOperation(false);
         console.error("Errore nel salvataggio dell'operazione:", error);
         errorNotification("Errore durante il salvataggio del operazione");
      }
    
  };

    ///////////////////////////////////////////////////////////////////////////////////////////
            //////////////////// funzioni della modal di salvataggio ///////////////
   ///////////////////////////////////////////////////////////////////////////////////////////
   return (
      <CreateOperationDataContext.Provider
         value={{
            channelsGroupObjLabel,
            channelsOptions,
            globalContext,

            handleFormChange,
            insertShortcode,
            setFormChanged,
            onInputFocus,
            formChanged,
            form,

            selectedAudienceTitles,
            setSelectedCoupon,
            selectedAudience,
            selectedCoupon,
            totalUsers,
            
            operationData,
            schedulingData,

            pushNotificationData,
            whatsAppData,
            formValues,
            couponData,
            emailData,
            smsData,

            colorPushNotification,
            colorWhatsApp,
            colorCoupons,
            colorEmail, 
            colorSms,
         }} 
      >
         <Form
            onValuesChange={handleFormChange}
            onFieldsChange={(_, allFields) => {
               const hasErrors = allFields.some(field => field.errors.length > 0);
               setFormIsValid(!hasErrors);
            }}
            onFinish={handleFinish}
            name="operation_form"
            layout='vertical'
            form={form}
            initialValues={{
               audience_ids: [], // array vuoto di default
            }}
         >
            <div className='di-card mt-10 mx-10'>
               
               {/* ------------ monitor e telecomando del wizard ------------ */}
               <div className="mb-20 border-solid p-10 radius-2 w-100 flex align-center flex-wrap gap-10 space-between">
                  <Button
                     className='flex-grow mw-xxs'
                     type="primary"
                     onClick={prev}
                     disabled={current === 0}
                  >
                     Indietro
                  </Button>

                  {current < totalSteps - 1 ? 
                     <Button
                        size={"big"}
                        className='flex-grow mw-xxs'
                        type="primary"
                        onClick={next}
                        disabled={
                           (current === 1 && !formIsValid) || !(
                              userId
                                 ? selectedValues.length > 0
                                 : (current === 0 && selectedAudience?.length > 0) ||
                                 (current === 1 && selectedValues.length > 0) ||
                                 current > 1
                           )
                        }
                     >
                        Avanti
                     </Button>
                  :
                     <Button
                        size={"big"}
                        className='flex-grow mw-xxs'
                        icon={<FlagOutlined />}
                        onClick={handleFinish}
                        type="primary"
                        disabled={!formIsValid}
                     >
                        Pubblica
                     </Button>
                  }
               </div>
               {/* ------------ monitor e telecomando del wizard ------------ */}
               
               {/* ------------ passi del wizard ------------  */}
               <Steps
                  direction={ifViewportGreaterThan("md") ? 'horizontal' : 'vertical'}
                  items={filteredSteps}
                  current={current}
               />
               {/* ------------ passi del wizard ------------  */}
               
               {/* ------------ contenuto ------------ */}
               <div className="mt-20">
                  <div style={{ display: (userId ? current + 1 : current) === 0 ? 'block' : 'none' }}>
                     <MarketingOperationCreateSelectAudience
                        setSelectedAudience={setSelectedAudience}
                        selectedAudience={selectedAudience}
                        contextValue={contextValue}
                        onChange={onClickAudience}
                     />
                  </div>

                  <div style={{ display: (userId ? current + 1 : current) === 1 ? 'block' : 'none' }}>
                     <MarketingOperationCreateSelectChannel
                        setSelectedValues={setSelectedValues}
                        selectedValues={selectedValues}
                        contextValue={contextValue}
                     />
                  </div>

                  <div style={{ display: (userId ? current + 1 : current) === 2 ? 'block' : 'none' }}>
                     <MarketingOperationCreateSelectPriority
                        selectedChannels={selectedValues}
                     />
                  </div>

                  <div style={{ display: (userId ? current + 1 : current) === 3 ? 'block' : 'none' }}>
                     <MarketingOperationCreateSchedule
                        setRepeatFrequency={setRepeatFrequency}
                        setMonthlyOption={setMonthlyOption}
                        repeatFrequency={repeatFrequency}
                        setSelectedDays={setSelectedDays}
                        monthlyOption={monthlyOption}
                        selectedDays={selectedDays}
                     />
                  </div>
               </div>

               {/* ------------ contenuto ------------ */}
      
            </div>
         </Form>


          {/* ------------ modal per salvare i dati -----------— */}
          <Modal
            okText={<><SaveOutlined /> Salva</>}
            title="Prima di salvare..."
            onCancel={handleCancel}
            cancelText="Annulla"
            onOk={saveOperation}
            okButtonProps={
               {
                  disabled: savingOperation,
                  loading:savingOperation
               }
            }
            open={openSaveModal}
          >
          <Typography className='mb-20'>Inseriamo i dati dell'operazione in modo da poterla facilmente riconoscere</Typography>
            <Form form={operationGeneralInfoForm} layout="vertical">
              <Form.Item 
                name="operationName" 
                initialValue={operationData ? operationData.title : `Operazione del ${nowDateTimeIta}`}
              >
                <Input
                  placeholder={`Operazione del ${nowDateTimeIta}`} 
                  prefix={<NotificationOutlined />}
                  maxLength={50}
                  showCount
                  size="large"
                />
              </Form.Item>

              <Form.Item
                name="operationDescription"
                initialValue={operationData ? operationData.description : ``}
              >
                <Input.TextArea
                  placeholder="Descrizione dell'operazione"
                  className="mt-10 mb-20"
                  maxLength={150}
                  showCount
                  style={{ height: 120 }}
                />
              </Form.Item>
            </Form>
          </Modal>
         {/* ------------ modal per salvare i dati -----------— */}
         
      </CreateOperationDataContext.Provider>
   )
}
